module.exports = __webpack_public_path__ + "img/4.61575604.jpg";